import { nanoid } from "../utility/index.js";
import { z } from "zod";
import { nanoidSchema, slugify } from "../utility/index.js";
import { randomThemeSlug } from "@scalar-org/random-slug";
const themeSchema = z.preprocess(
  (arg) => {
    if (!arg) return arg;
    if (typeof arg === "object") arg.identifier = slugify(arg.name);
    return arg;
  },
  z.object({
    uid: nanoidSchema,
    name: z.string().transform(slugify),
    description: z.string(),
    theme: z.string(),
    slug: z.string().transform(slugify)
  })
);
const defaultTheme = (cssString = "") => ({
  uid: nanoid(),
  name: "Default Theme",
  slug: randomThemeSlug(),
  description: "",
  theme: cssString
});
export {
  defaultTheme,
  themeSchema
};
//# sourceMappingURL=index.js.map
